export default "__VITE_ASSET__9vy0Yw5X__"